export const backSlrText = {
  values: [
    { value: 'BackSlr', text: 'Ja', score: 1 },
    { value: 'BackSlr', text: 'Nei', score: 0 },
    { value: 'BackSlr', text: 'Ikke aktuelt', score: -1 },
  ],
};
